/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_View_First_SlideInputs */

const en_onboarding_view_first_slide = /** @type {(inputs: Onboarding_View_First_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View first slide`)
};

const es_onboarding_view_first_slide = /** @type {(inputs: Onboarding_View_First_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver la primera diapositiva`)
};

/**
* | output |
* | --- |
* | "View first slide" |
*
* @param {Onboarding_View_First_SlideInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_view_first_slide = /** @type {((inputs?: Onboarding_View_First_SlideInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_View_First_SlideInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_view_first_slide(inputs)
	return en_onboarding_view_first_slide(inputs)
});